export const environment = {
  production: false,
  apiUrl: 'https://api.tecnologiaasap.com.br',
  baseUrl: 'https://api.tecnologiaasap.com.br',
  pusher: {
    key: 'eaf41725f3b027147953',
  },
  firebase: {
    apiKey: "AIzaSyCfWrS1friAWZyDBs8z5tVIhGBIRvaOI2c",
    authDomain: "actionaid-2b0ae.firebaseapp.com",
    databaseURL: "https://actionaid-2b0ae.firebaseio.com",
    projectId: "actionaid-2b0ae",
    storageBucket: "actionaid-2b0ae.appspot.com",
    messagingSenderId: "66447181423"
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts